import React from 'react'
import SelectField from 'material-ui-legacy/SelectField'
import MenuItem from 'material-ui-legacy/MenuItem'

import { mapObject } from '../../lib/util.js'

/*
Props:
- options: Array of objects where keys are labels and values are actual values.
           e.g.: { 'Option 1': 1, 'Option 2': 2 }
- floatingLabelText, value, onChange etc.: passed down to <SelectField>
*/
const SimpleSelect = props => {
  const { options, value, ...restProps } = props

  return (
    <SelectField value={value} {...restProps}>
      {mapObject(options, (optionLabel, optionValue) => (
        <MenuItem
          key={`${optionLabel}${optionValue}`}
          value={optionValue}
          primaryText={optionLabel}
        />
      ))}
    </SelectField>
  )
}

export default SimpleSelect



// WEBPACK FOOTER //
// ./src/components/UI/SimpleSelect.jsx